export function getApiBase(version: 'v1' | 'v2' = 'v1') {
  const {
    public: { apiBase },
  } = useRuntimeConfig()
  return `${apiBase.replace(/\/+$/, '').replace(/\/v[12]$/, '')}/${version}`
}
